import getLocalTrigger from "../../../utils/get-local-trigger";
import run from "../../animate/run";

/**
 * Initialize `animate` triggers and run them on page load
 * @param {Map<TorusElement, MainClassProps> | null} [targets]
 */
const initAnimate = (targets) => {
  /** Get all "animate" triggers */
  const animates = getLocalTrigger("animate", targets);

  /** Loop trough them and fire the animate event */
  for (const [main, names] of animates) {
    for (const name of names) {
      run(main.events.get(`animateenter:${name}`), "enter", true);
    }
  }
};

export default initAnimate;
